import React from 'react';
import { Route } from 'react-router'

import IntelligenceInMomentDateTab from './intelligenceInMomentDateTab'
import IntelligenceInTimeRangeDateTab from './intelligenceInTimeRangeDateTab'

const IntelligenceDateTab = () => {
  let intelligenceRangeType = sessionStorage.getItem('intelligenceRangeType')

  return (
    <React.Fragment>
      <Route exact path='/cars/:id/intimerange' component={IntelligenceInTimeRangeDateTab} />
      <Route exact path='/cars/:id/inmoment' component={IntelligenceInMomentDateTab} />
      <Route exact path='/cars/:id' component={
        intelligenceRangeType === 'intimerange'
          ? IntelligenceInTimeRangeDateTab
          : IntelligenceInMomentDateTab
      } />
    </React.Fragment>
  )
}

export default IntelligenceDateTab